import React, { useContext, useEffect, useState } from 'react';
import IMAGE from '../Assets/plsprint.png';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import UserContext from '../context/UserContext';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [company, setCompany] = useState(null);
  const [name, setName] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [remember, setRemember] = useState(false);
    const [sales , setSales] = useState("");
const [button, setButton] = useState(false); 
  const nav = useNavigate();
  const { setUserinfo, userInfo, login,apiURL } = useContext(UserContext);

  // Check if user is already logged in
  useEffect(() => {
    if (sessionStorage.getItem('flipped') === 'true') {
      nav('/dashboard', { replace: true });
    }
  }, []);



  // Handle remember checkbox change and update localStorage
  const handleRememberChange = (e) => {
    const isChecked = e.target.checked;
    setRemember(isChecked);
    if (isChecked) {
      localStorage.setItem('remember', 'true');
      localStorage.setItem('email', email);
    } else {
      localStorage.removeItem('remember');
      localStorage.removeItem('email');
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
setButton(true)
    if (pass !== confirmPass) {
      toast.warning('Passwords do not match');
      setButton(false)
      return;
    }

    const data = { email, pass,company,name,sales };

    try {
      const res = await axios.post(`${apiURL}/users/signup`, data)
      .then(res => {
    
        if(res.data.status !== 200){
 return toast.error(res.data.message)
        }
 toast.success(res.data.message)
    nav('/', { replace: true });
  
     setButton(false)
  })
      .catch(err => console.log(err))

    //   if (res.data.status === 200) {
    //    // login(email, pass);
    //     toast.success('Registration successful');
    //    // nav('/dashboard');
    //   } else {
    //     toast.error(res.data.msg || 'Registration failed');
    //   }
    } catch (err) {
      console.error(err);
      toast.error('An error occurred during registration');
       setButton(false)
     }
      
  };

  return (
    <>
      <div className="w-full h-[8vh] bg-[#7ABB43] text-white flex items-center justify-center text-3xl shadow-2xl">
        PLS Print Client Uploader
      </div>

      <div className="relative w-2/4 flex justify-start items-start h-[90vh] mx-auto pt-[75px] flex-col">
        <div className="w-full flex items-center justify-center">
          <img src={IMAGE} width="20%" alt="PLS Print Logo" />
        </div>

        <section className="bg-gray-50 dark:bg-gray-900 border-grey border-1 mx-auto mt-[25px]">
          <div className="flex flex-col items-center justify-center px-6 py-8">
            <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
              <div className="px-6 space-y-4 md:space-y-4 sm:p-6">
                <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  Create a new account
                </h1>
                <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left"
                    >
                      Your email
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      name="email"
                      id="email"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="name@company.com"
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left"
                    >
                      Your Name
                    </label>
                    <input
                      type="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      name="name"
                      id="name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Your Name"
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="password"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      value={pass}
                      onChange={(e) => setPass(e.target.value)}
                      name="password"
                      id="password"
                      placeholder="••••••••"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="confirm-password"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left"
                    >
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      value={confirmPass}
                      onChange={(e) => setConfirmPass(e.target.value)}
                      name="confirm-password"
                      id="confirm-password"
                      placeholder="••••••••"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="password"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left"
                    >
                      Company
                    </label>
                    <input
                      type="text"
                      value={company}
                      onChange={(e) => setCompany(e.target.value)}
                      name="company"
                      id="company"
                      placeholder="Company Name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      autoComplete="off"
                      required
                    />
                  </div>
                    <div>
                    <label
                      htmlFor="password"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left"
                    >
                      Sales Rep (if known)
                    </label>
                    <input
                      type="text"
                      value={sales}
                      onChange={(e) => setSales(e.target.value)}
                      name="sales"
                      id="sales"
                      placeholder="Sales Rep"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      autoComplete="off"
                      required
                    />
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          id="remember"
                          aria-describedby="remember"
                          type="checkbox"
                          className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-1 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                          checked={remember}
                          onChange={handleRememberChange}
                        />
                      </div>
                      <div className="ml-3 text-sm">
                        <label htmlFor="remember" className="text-gray-500">
                          Remember me
                        </label>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="w-full text-white bg-blue-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                     disabled={button}
                  >
                    Sign up
                  </button>
                  <div className="m-0 p-0 mt-[20px] text-left">
                    Already have an account?{' '}
                    <Link className="text-blue-700" to="/">
                      Sign in here
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Signup;